import {
  IBannerFieldConfigurationClient,
  IBannerFieldConfigurationServer,
} from "./interface";

export const transformBannerConfigClientToServer = (
  fieldConfigClient: IBannerFieldConfigurationClient
): IBannerFieldConfigurationServer => {
  const { bannerTabValue,buttonAction,enableIcon,isEncryptionEnabled,isHideFieldForSubmission } = fieldConfigClient;
  const fieldConfigServer:IBannerFieldConfigurationServer = {
    bannerTabValue:bannerTabValue,
    buttonAction: buttonAction ,
    enableIcon: enableIcon,
    isEncryptionEnabled: isEncryptionEnabled,
    isHideFieldForSubmission: isHideFieldForSubmission,
  };
  return fieldConfigServer;
};

export const transformBannerConfigServerToClient = (
  fieldConfigServer: IBannerFieldConfigurationServer
): IBannerFieldConfigurationClient => {
  const {  buttonAction, bannerTabValue,enableIcon,isEncryptionEnabled,isHideFieldForSubmission } = fieldConfigServer;
  const fieldConfigClient:IBannerFieldConfigurationClient = {
    bannerTabValue:bannerTabValue,
    buttonAction: buttonAction ,
    enableIcon: enableIcon,
    isEncryptionEnabled: isEncryptionEnabled,
    isHideFieldForSubmission: isHideFieldForSubmission,
  };
  return fieldConfigClient;
};
